import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'

const MagElement = ({ data, action, openPopup, isDesktop = false }) => {
  const { name, isAvailableForRentNow, attrs, free_now_to_rent_count, count, for_rent, badge, data: { monthlyGrossPrice } = {} } = data || {}
  const forRentDates = Object.values(for_rent || {})

  const { t } = useTranslation('mapDetails')

  return (
    <div className={` magElement ${badge ? ' --badge' : ''} ${isDesktop ? '--desktop' : ''} ${isAvailableForRentNow || forRentDates.length > 0 ? '' : '--orderLast'}`}>

      {badge && !isDesktop && <div className='badge' style={{ borderColor: badge.borderColor, backgroundColor: badge.bgColor, color: badge.textColor }}>{badge.text}</div>}

      <div className='magElement__head'>
        <div className='amount'>
          <div className='amount__bg'><span className={`${countBadge(free_now_to_rent_count)}`}></span></div>
          <div className='amount__desc'>{t('amount')}: {free_now_to_rent_count}</div>
        </div>
        <h2>{name}</h2>
        {badge && isDesktop && <div className='badge' style={{ borderColor: badge.borderColor, backgroundColor: badge.bgColor, color: badge.textColor }}>{badge.text}</div>}
        {!isDesktop && <span onClick={() => openPopup('details')}>{t('seeDetails')}</span>}
        {isDesktop && <div onClick={() => openPopup('details')}><i className='icon icon--info'></i></div>}
      </div>

      <div className='wrap'>
        {!isDesktop ? <> <div className='magElement__important'>
          {attrs?.map((item, idx) => {
            return (
              item.isImportant && <div key={idx} className='magElement__important__item'>
                <i className={`icon icon--${item.key}`} />
                <span>{item.name}</span>
              </div>
            )
          })}
          <span className='divider'></span>
        </div>

          {attrs?.some(item => !item.isImportant) && <div className='magElement__body'>
            {attrs?.map((item, idx) => {
              return (
                !item.isImportant && <div key={idx} className='attrItem'>
                  <i className={`icon icon--${item.key}-bold`} />
                  <span>{item.name}</span>
                </div>
              )
            })}
          </div>}</>
          : <div className='magElement__desktopBody'>
            {attrs?.map((item, idx) => {
              return (
                item.isImportant && <div key={idx} className='desktopBody__item'>
                  <i className={`icon icon--${item.key}-bold`} />
                  <span>{item.name}</span>
                </div>
              )
            })}
            {attrs?.map((item, idx) => {
              return (
                !item.isImportant && <div key={idx} className='desktopBody__item'>
                  <i className={`icon icon--${item.key}-bold`} />
                  <span>{item.name}</span>
                </div>
              )
            })}
          </div>}

        <div className='magElement__footer'>
          <div className='magElement__footer__price'>
            <span>{Number(monthlyGrossPrice)} zł</span>
            <span>{t('monthly')}</span>
          </div>

          <ArrowBtn
            className={`${isAvailableForRentNow || forRentDates.length > 0 ? '' : '--black'}`}
            enlarged
            disabled={!count}
            text={isAvailableForRentNow ? t('rentNow') :
              forRentDates.length > 0 ? `${t('rentFrom')} ${forRentDates[0]}`
                : t('notifyMeAboutAvailability')}
            action={() => {
              if (isAvailableForRentNow) action()
              else if (forRentDates[0]) action(forRentDates[0])
              else openPopup('availability')
            }} />

        </div>
      </div>
    </div>
  )
}

export const countBadge = (freeCount) => {
  if (freeCount < 1) {
    return "zero"
  } else if (freeCount >= 1 && freeCount <= 5) {
    return "empty"
  } else if (freeCount > 5 && freeCount <= 20) {
    return "average"
  } else {
    return "full"
  }
}

export default MagElement